<template>
  <router-link :to="{path:'ProductsList',query:{categoryID:item.ProductCategoryId}}" class="third-bg d-block rounded-lg black--text" >
    <v-img :src="$replaceHttps(item.FileUrl)" height="auto" min-height="200"></v-img>
    <div class="text-center my-3 pb-2 font-weight-bold font-16 ">
      {{ item.Name }}
    </div>
  </router-link>
</template>

<script>
export default {
  name: "ShoppingCategoryCard",
  props: ['item'],
  methods: {

  }
}
</script>
<style scoped>

</style>

